/* 相关视频 */
import React from 'react'
import get from 'lodash/get'

import { IFeedData } from 'lib/fetch-feed'
import formatDuration from 'lib/format-duration'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import ArticleLink from 'Components/links/article-link'
import Image from 'Components/image'

interface IProps {
  videos: IFeedData[]
}

export default function Video({ videos }: IProps) {
  /* 渲染视频列表 */
  function renderVideoList() {
    return (
      <section className="clearfix">
        {videos.slice(0, 4).map((item: IFeedData, index) => (
          <ArticleLink
            onClick={() => {
              sendTeaCommEvent('click_related_video', {
                rank: index,
                group_id: item.unique_id_str,
              })
            }}
            key={item.unique_id_str}
            gid={item.unique_id_str}
          >
            <div className="fl box">
              <div className="cover">
                <Image
                  src={
                    get(
                      item,
                      'info.video_detail_info.detail_video_large_image.url',
                      ''
                    ) || get(item, 'info.image_list[0].url')
                  }
                />
                <span>{formatDuration(item.info.video_duration)}</span>
              </div>
              <p className="line-2">{item.info.title}</p>
            </div>
          </ArticleLink>
        ))}
        <style jsx>
          {`
            section {
              margin: 0 8px 18px 16px;
            }
            .box {
              margin-top: 16px;
              margin-right: 6px;
            }
            .cover {
              position: relative;
              overflow: hidden;
              width: 176px;
              height: 100px;
              cursor: pointer;
            }
            span {
              position: absolute;
              right: 4px;
              bottom: 4px;
              display: block;
              width: 94px;
              height: 40px;
              line-height: 40px;
              font-size: 20px;
              text-align: center;
              border-radius: 30px;
              color: #fff;
              transform: scale(0.5);
              transform-origin: right bottom;
              background-color: rgba(0, 0, 0, 0.4);
            }
            p {
              width: 176px;
              height: 40px;
              margin-top: 8px;
              cursor: pointer;
            }
          `}
        </style>
      </section>
    )
  }
  return (
    <div className="whole">
      <h3>热门视频</h3>
      {renderVideoList()}
      <style jsx>
        {`
          .whole {
            margin-bottom: 10px;
            border: solid 1px #e6e6e6;
          }
          h3 {
            position: relative;
            width: 390px;
            line-height: 60px;
            padding-left: 26px;
            font-size: 18px;
            font-weight: 500;
            border-bottom: solid 1px #e6e6e6;
          }
          h3::before {
            content: '';
            position: absolute;
            top: 21px;
            left: 16px;
            width: 6px;
            height: 18px;
            background: #ffe100;
          }
          .cover {
            width: 240px;
            height: 160px;
            margin: 8px auto 16px;
          }
        `}
      </style>
    </div>
  )
}
